import { render, staticRenderFns } from "./UsStep5.vue?vue&type=template&id=8e2e3f3a"
import script from "./UsStep5.vue?vue&type=script&lang=js"
export * from "./UsStep5.vue?vue&type=script&lang=js"
import style0 from "./UsStep5.vue?vue&type=style&index=0&id=8e2e3f3a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports